module.exports = __webpack_public_path__ + "img/189.fee6560a.jpg";